import Vue from 'vue'
import VueI18n from 'vue-i18n'

import sk from 'vuetify/lib/locale/sk'

Vue.use(VueI18n)

const messages = {
    sk: {
        ...require('@/locales/sk.json'),
        $vuetify: sk
    }
}

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'sk',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'sk',
    messages,
})